// Import the functions you need from the SDKs you need
import { initializeApp, getApps } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // ✅ Import Auth
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const fireConfigz = {
  apiKey: process.env.REACT_APP_MAIN_KEY_STORE,
  authDomain: "main-store-33393.firebaseapp.com",
  projectId: "main-store-33393",
  storageBucket: "main-store-33393.firebasestorage.app",
  messagingSenderId: "427790086064",
  appId: process.env.REACT_APP_MAIN_ID_STORE,
};

// Initialize Firebase
const MainApp =
  getApps().find((app) => app.name === "main-store") ||
  initializeApp(fireConfigz, "main-store");
export const MainDb = getFirestore(MainApp);
export const userAuth = getAuth(MainApp);
